import apiClient from './api';
import { Client, NewClient, UpdateClient } from '../types/client';

const getClients = async (searchTerm?: string): Promise<Client[]> => {
  const response = await apiClient.get<Client[]>('/clients/', {
    params: { search: searchTerm },
  });
  return response.data;
};

const createClient = async (clientData: NewClient): Promise<Client> => {
  const response = await apiClient.post<Client>('/clients/', clientData);
  return response.data;
};

const updateClient = async (id: number, clientData: UpdateClient): Promise<Client> => {
  const response = await apiClient.patch<Client>(`/clients/${id}/`, clientData);
  return response.data;
};

export const crmService = {
  getClients,
  createClient,
  updateClient,
};